'use client';

import { Button } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { center, grid } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import {
  AptosIcon,
  BnbIcon,
  KaiaIcon,
  OverprotocolIcon,
  TalonIcon,
  TetherIcon,
  TonIcon,
  WlfiIcon,
} from '@web/assets/svgs';

import { maxWStyles } from '../_styles';

const partners = [
  {
    name: 'Tether',
    image: <TetherIcon />,
    url: 'https://tether.to/en/',
  },
  {
    name: 'Talon',
    image: <TalonIcon />,
    url: 'https://www.talon.gg/',
  },
  {
    name: 'Wlfi',
    image: <WlfiIcon />,
    url: 'https://worldlibertyfinancial.com/',
  },
  {
    name: 'Ton',
    image: <TonIcon />,
    url: 'https://ton.foundation/en',
  },
  {
    name: 'BNB',
    image: <BnbIcon />,
    url: 'https://www.bnbchain.org/en',
  },
  {
    name: 'Aptos',
    image: <AptosIcon />,
    url: 'https://aptosfoundation.org/',
  },
  {
    name: 'Kaia',
    image: <KaiaIcon />,
    url: 'https://www.kaia.io/',
  },
  {
    name: 'Overprotocol',
    image: <OverprotocolIcon />,
    url: 'https://over.network/',
  },
];

// TODO: refact to contentful
const Partners = () => {
  const onClickPartnershipLearnMore = () => {
    segment.track(MainEvent.IntroducePartnershipLearnMoreClick, {
      event_location: 'main_page_view',
    });
  };

  return (
    <div className={css(maxWStyles, { pb: { base: 48, tablet: 96 } })}>
      <h2 className={css({ textStyle: 'Title/M', color: 'content.default.level-4' })}>Our partners</h2>
      <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3', pt: 16 })}>
        We’re proud to collaborate with trusted partners who share our mission to deliver a seamless and
        high-performance trading experience.
      </p>
      <ul
        className={grid({
          pt: 32,
          gap: { base: 8, tablet: 16 },
          gridTemplateColumns: {
            base: 'repeat(auto-fit, minmax(160px, 1fr))',
            tablet: 'repeat(auto-fit, minmax(288px, 1fr))',
          },
          gridTemplateRows: {
            base: 'repeat(auto-fit, minmax(48px, 1fr))',
            tablet: 'repeat(auto-fit, minmax(100px, 1fr))',
          },
        })}
      >
        {partners.map((partner) => (
          <li
            key={partner.name}
            className={css({
              bgColor: 'background.default.level-1',
              rounded: { base: 4, tablet: 8 },
              minH: { base: 48, tablet: 100 },
            })}
          >
            <a
              className={center({ w: '100%', h: '100%', '& > svg': { width: '100%', height: '100%' } })}
              href={partner.url}
              target='_blank'
              onClick={onClickPartnershipLearnMore}
            >
              {partner.image}
            </a>
          </li>
        ))}
      </ul>
      <div className={center({ mt: 40 })}>
        <Button label='Learn more' href='/about' as='a' size='large' css={{ minW: 120 }} />
      </div>
    </div>
  );
};

export default Partners;
